"use strict";
// NOTE: We're building up a library of date utils so that we can move away from moment (it is way too heavyweight for what we need
//       and it makes unit testing more challenging).
Object.defineProperty(exports, "__esModule", { value: true });
// public consts
exports.ONE_HOUR = 60 * 60 * 1000;
exports.ONE_DAY = 24 * 60 * 60 * 1000;
exports.ONE_YEAR = 365 * exports.ONE_DAY;
// private consts
var DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
var DAYS_3LETTER = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
var MONTHS = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
];
var MONTHS_3LETTER = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
exports.cloneDate = function (date) {
    if (!date) {
        return null;
    }
    var newDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
    return newDate;
};
exports.getStartOfDay = function (date) {
    if (!date) {
        return null;
    }
    var newDate = exports.cloneDate(date);
    newDate.setHours(0);
    newDate.setMinutes(0);
    newDate.setSeconds(0);
    newDate.setMilliseconds(0);
    return newDate;
};
/**
 * Accepts a date string and converts to a UNIX timestamp
 * @param date a date/time string
 */
exports.parseISODate = function (date) {
    var isoDateRegEx = /\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z)/;
    if (!date || date.match(isoDateRegEx) === null) {
        return null;
    }
    return Date.parse(date);
};
/**
 * Accepts a date string in MM/DD/YYYY format and returns a date Object
 * @param date a date/time string
 */
exports.parseMMDDYYYY = function (date) {
    var dateStringRegEx = /^\d{1,2}\/\d{1,2}\/\d{4}$/;
    if (!date || date.match(dateStringRegEx) === null) {
        return null;
    }
    var dateParts = date.split('/');
    var dateMonth = parseInt(dateParts[0], 10);
    var dateDay = parseInt(dateParts[1], 10);
    var dateYear = parseInt(dateParts[2], 10);
    return new Date(dateYear, (dateMonth - 1), dateDay, 0, 0, 0, 0);
};
/**
 * Determines the difference between days ignoring the time component.
 *
 * NOTE: This isn't intended to handle big differences between dates, so it throw
 *  an exception if you use it for that.
 * @param day1 earlier date with irrelevent time component (it will be ignored)
 * @param day2 later date with irrelevent time component (it will be ignored)
 */
exports.getDayDiffIgnoringTime = function (day1, day2) {
    if (!day1 || !day2) {
        return null;
    }
    var day1start = exports.getStartOfDay(day1);
    var day2start = exports.getStartOfDay(day2);
    var result = Math.round((day2start.getTime() - day1start.getTime()) / exports.ONE_DAY);
    return result;
};
exports.formatAsDayOfWeek = function (day) {
    if (!day) {
        return null;
    }
    var dayOfWeek = DAYS[day.getDay()];
    return dayOfWeek;
};
exports.formatAs3LetterDayOfWeek = function (day) {
    if (!day) {
        return null;
    }
    var dayOfWeek = DAYS_3LETTER[day.getDay()];
    return dayOfWeek;
};
var formatAs2Digits = function (val) {
    return val < 10 ? "0" + val : "" + val;
};
exports.formatAs2DigitDayOfMonth = function (day) {
    if (!day) {
        return null;
    }
    var dayOfMonth = day.getDate();
    return formatAs2Digits(dayOfMonth);
};
exports.formatAsMonth = function (day) {
    if (!day) {
        return null;
    }
    var month = day.getMonth();
    return MONTHS[month];
};
exports.formatAs3LetterMonth = function (day) {
    if (!day) {
        return null;
    }
    var month = day.getMonth();
    return MONTHS_3LETTER[month];
};
exports.getDaySuffix = function (dayOfMonth) {
    if (!dayOfMonth) {
        return null;
    }
    switch (dayOfMonth) {
        case 1:
        case 21:
        case 31: {
            return 'st';
        }
        case 2:
        case 22: {
            return 'nd';
        }
        case 3:
        case 23: {
            return 'rd';
        }
        default: {
            return 'th';
        }
    }
};
exports.formatAsMonthDay = function (date) {
    if (!date) {
        return null;
    }
    var dayText = date.getDate() + exports.getDaySuffix(date.getDate());
    return exports.formatAsMonth(date) + " " + dayText;
};
/**
 * Format is equivalent to moment's M/D/YYYY
 * @param date A JavaScript Date type
 */
exports.formatAsMDYYYY = function (date) {
    if (!date) {
        return null;
    }
    return date.getMonth() + 1 + "/" + date.getDate() + "/" + date.getFullYear();
};
/**
 * Format is equivalent to moment's MM/DD/YYYY
 * @param date A JavaScript Date type
 */
exports.formatAsMMDDYYYY = function (date) {
    if (!date) {
        return null;
    }
    var formattedDate;
    if (typeof date === 'string') {
        var dateFromStr = exports.cloneDate(exports.parseMMDDYYYY(date));
        formattedDate = formatAs2Digits(dateFromStr.getMonth() + 1) + "/" + formatAs2Digits(dateFromStr.getDate()) + "/" + dateFromStr.getFullYear();
    }
    else {
        formattedDate = formatAs2Digits(date.getMonth() + 1) + "/" + formatAs2Digits(date.getDate()) + "/" + date.getFullYear();
    }
    return formattedDate;
};
/**
 * Formats a date as YYYYMMDD or YYYY-MM-DD
 * @param date a Date object
 * @param includeHyphens Boolean indicating whether to include hyphens between date values, default true
 * @returns A formatted date
 */
exports.formatAsYYYYMMDD = function (date, includeHyphens) {
    if (includeHyphens === void 0) { includeHyphens = true; }
    var day = formatAs2Digits(date.getDate());
    var month = formatAs2Digits(date.getMonth() + 1);
    var year = date.getFullYear();
    var separator = includeHyphens ? '-' : '';
    var formattedDate = [year, month, day].join(separator);
    return formattedDate;
};
/**
 * Format is equivalent to ico date 'h:mma'
 * @param date a JavaScript Date type
 */
exports.formatAsTime = function (date) {
    if (!date) {
        return '';
    }
    var hour = date.getHours() || 12;
    var minutes = date.getMinutes();
    var isPM = hour > 12;
    var normalizedHour = isPM ? hour - 12 : hour;
    var normalizedMinutes = minutes ? (minutes < 10 ? "0" + minutes : minutes) : '00';
    var dayTime = isPM ? 'pm' : 'am';
    return normalizedHour + ":" + normalizedMinutes + dayTime;
};
/**
 * Format is equivalent to ico date 'MMMM DD, YYYY at h:mma'
 * @param date a JavaScript Date type
 */
exports.formatAsIcoValuationDate = function (date) {
    if (!date) {
        return null;
    }
    var parsed = exports.parseISODate(date);
    var thisDate = exports.cloneDate(new Date(parsed));
    var hours = function () {
        var hours = thisDate.getUTCHours();
        if (hours > 12) {
            hours -= 12;
        }
        else if (hours === 0) {
            hours = 12;
        }
        return hours;
    };
    var ampm = thisDate.getHours() >= 12 ? 'pm' : 'am';
    return exports.formatAsMonth(thisDate) + " " + exports.formatAs2DigitDayOfMonth(thisDate) + ", " + thisDate.getFullYear()
        + (" at " + hours() + ":" + (formatAs2Digits(thisDate.getMinutes()) + ampm));
};
/**
 * Format is equivalent to 'Tuesday, June 25th 2019'
 * @param date a JavaScript Date type
 */
exports.formatAsDealExpirationDate = function (date) {
    if (!date) {
        return null;
    }
    return exports.formatAsDayOfWeek(date) + ", " + exports.formatAsMonthDay(date) + " " + date.getFullYear();
};
exports.addDaysToDate = function (date, days) {
    if (!date) {
        return null;
    }
    if (!days) {
        return exports.cloneDate(date);
    }
    return new Date(date.getTime() + exports.ONE_DAY * days);
};
exports.addHoursToDate = function (date, hours) {
    if (!date) {
        return null;
    }
    if (!hours) {
        return exports.cloneDate(date);
    }
    return new Date(date.getTime() + exports.ONE_HOUR * hours);
};
function formatUtcDateTimeToDateOnly(strVal) {
    var errorMessage = 'Invalid UTC Date';
    if (!strVal) {
        return errorMessage;
    }
    // We need to force the date to UTC if the Z is not already present
    var dateString = strVal;
    if (strVal.indexOf('Z') === -1) {
        dateString = strVal + "Z";
    }
    var parsed = new Date(dateString);
    var month = parsed.getUTCMonth();
    var day = parsed.getUTCDate();
    var year = parsed.getUTCFullYear();
    var dateObj = new Date(year, month, day);
    var formattedDate = exports.formatAsMDYYYY(dateObj);
    if (!formattedDate) {
        return errorMessage;
    }
    return formattedDate;
}
exports.formatUtcDateTimeToDateOnly = formatUtcDateTimeToDateOnly;
